/* eslint-disable */
import Vue from 'vue'
import Router from 'vue-router'
import store from "@/store";
import Home from './views/Home.vue'
import Login from '@/views/home/Home-login.vue'
import Guide from '@/views/guide/Guide.vue'
import StrategyList from '@/views/strategy/Strategy-list.vue'
import Api from '@/views/api/Api.vue'
import Market from '@/views/market/Market.vue'
import Assets from '@/views/assets/Assets.vue'
import Task from '@/views/task/Task.vue'
import Config from '@/views/config/Config.vue'
import TaskDetail from '@/views/task/task-detail.vue'
import TaskTradeInfo from '@/views/task/task-trate-info.vue'
import Statistic from '@/views/statistic/Statistic.vue'
import Demand from '@/views/demand/Demand.vue'
import Unilateral from "@/views/unilateral/Unilateral-strategy.vue";
import UnilateralStatic from "@/views/unilateral/Unilateral-static.vue";
import UnilateralContral from "@/views/unilateral/Unilateral-contral.vue";
import UserIndex from "@/views/user/User-main.vue";


Vue.use(Router)


export const constantRouterMap = [
    { path: '/login', component: Login, hidden: true },
    { path: '/404', component: () => import("@/views/404.vue"), hidden: true }
]


const router = new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/',
      redirect: '/login'
    },
    { path: '/user', redirect: '/user/index', meta: {title: '用户'} },
    { path: '/home', component: Home, name: 'home', meta: { title: '主页' } },
    { path: '/login', component: Login, meta: { title: '登录' } },
    { path: '/guide', component: Guide },
    { path: '/task/taskDetail', name: 'TaskDetail', component: TaskDetail, meta: { title: '任务明细' } },
    { path: '/task/taskTradeInfo', name: 'TaskTradeInfo',component: TaskTradeInfo },
    { path: '/404', component: () => import("@/views/404.vue"), name: "404Page", meta: {title: '没有页面'} },
    { path: '/unilateral/contral', name: "strategyContral", component: UnilateralContral, metal: {title: "策略监控"} },
    { path: '/user', name: 'userMain', component: UserIndex, metal: {title: "用户"}, children: [
      { path: '/user/index', name: "user", component: () => import("@/views/user/User-index.vue"), metal: {title: "用户主页"} },
      { path: '/user/static', name: "userStatic", component: () => import("@/views/user/User-static.vue"), metal: {title: "用户统计"} },
    ] },
    { path: '/temp/strategy', name: "tempStrategy", component: () => import("@/views/tempStrategy/Temp-strategy.vue")},

    // 新结构
    {path: '/main', name: 'main', component: () => import("@/views/Main.vue"), meta: {title: '首页'}, children: [
      // 单边策略
      { path: '/main/index', name: 'index', component: () => import("@/views/unilateral/Index.vue"), meta: {title: '单边策略'}, children: [
        { path: '/main/index/unilateral', name: 'unilateral' , component: Unilateral, meta: {title: '策略'}, children: [
  
        ]},
        { path: '/main/index/api',
          component: () => import("@/views/unilateral/Unilateral-api.vue"),
          meta: {title: '任务'}, children: [

          ]
        },
        {
          path: '/main/index/api/detail',
          component: () => import("@/views/unilateral/Unilateral-task-detail.vue"),
          name: 'unilateralTaskDetail',
          meta: {title: '明细'}
        },
        { path: '/unilateral/statistic', name: 'unilateralStatic', component: UnilateralStatic, meta: {title: '策略统计'} },
      ], redirect: '/main/index/unilateral'},
      // 套利策略
      { path: '/task', component: Task, meta: { title: '任务' } },
      { path: '/strategy', component: StrategyList, meta: { title: '套利策略' } },
      { path: '/demand', component: Demand, meta: { title: '需求' } },
      { path: '/config', component: Config, meta: { title: '配置' } },
      { path: '/statistic', component: Statistic, meta: { title: '统计' } },
      { path: '/assets', component: Assets, meta: { title: '资产' } },
      { path: '/assets/snapshot', component: () => import("@/views/assets/Asset-snapshot.vue"), meta: { title: '资产快照' } },
      { path: '/assets/snapshot/board', component: () => import("@/views/assets/Asset-snapshot-board.vue"), meta: { title: '快照面板' } },
      { path: '/api', component: Api, meta: { title: 'API' } },
      { path: '/market', component: Market, name: 'market', meta: { title: '行情' } },
      { path: '/main/tempStrategy', component: () => import("@/views/tempStrategy/Temp-strategy1.vue"), meta: {title: '临时策略1'} },
      { path: '/main/mill', component: () => import("@/views/mill/Mill-index.vue"), meta: {title: '矿机'} },
      { path: '/main/mill1', component: () => import("@/views/mill/Mill-static.vue"), meta: {title: '矿机1'} },
      { path: '/main/mill2', component: () => import("@/views/mill/Mill-static2.vue"), meta: {title: '矿机2'} },
      { path: '/coins', component: () => import("@/views/coins/coin_form.vue"), meta: {title: '代币列表'} },
      { path: 'mobile', component: () => import("@/views/mobileStrategy/mobileStrategy.vue"), meta: {title: '移动策略'}},
      {
        path: '/signal',
        component: () => import('@/views/signal/index.vue')
      },
      {
        path: '/simulate',
        component: () => import('@/views/simulate/index.vue')
      },
      {
        path: '/aveo',
        component: () => import('@/views/aevo/index.vue')
      },
      {
        path: '/badata',
        component: () => import('@/views/badata/index.vue'),
      },
      {
        path: '/binance/trading',
        component: () => import('@/views/binance_trading/index.vue')
      },
      {
        path: '/binance/currency',
        component: () => import('@/views/binance_currency/index.vue')
      }
    ], redirect: '/market'},
    
  ]
})

router.beforeEach((to, from, next) => {
  var token = store.state.token;
  let userPermission = store.state.userPermission
  if (token) {// 已登录
    if(!userPermission) {
      store.dispatch('getUserPermission').then(() => {
        userRouterPermissionNext(to, from, next)
      }).catch(err => {
        userRouterPermissionNext(to, from, next)
      })
    } else {
      userRouterPermissionNext(to, from, next)
      // userLevelNext(to, from, next)
    }
    // next();
  } else {// 未登录
    next({name: Login});  // 定向到登录页
  }
})

function userRouterPermissionNext(to, from, next) {
  let defaultPermission = store.state.defaultPermission
  let userRouterPermission = defaultPermission.concat(store.state.userPermission ? store.state.userPermission.column : [])

  let flag = userRouterPermission.find(element => {
    // const reg = new RegExp(`${element}`)
    // return reg.test(to.path)
    return element === to.path
  })
  if(flag) {
    // userLevelNext(to, from, next)
    next()
  } else {
    next({
      path: '/home'
    })
  }
}

function userLevelNext(to, from, next) {
  var userLevel = store.state.userLevel;
  var userPermissionList = store.state.userPermissionList;

  if (userLevel == '0') {
    if (userPermissionList.indexOf(to.name) !== -1) { // 用户列表
      next();
    } else {// 非用户列表, 返回404
      if (to.path === '/404' || to.path == '/' || to.path == '/login') {
        next();
      } else {
        next({path: '/404'})
      }
    }
  } else {
    next();
  }
}


export default router;
